<template>
  <div></div>
</template>
<script>
export default {
  props:{
    transform:{
      type: Object,
      required: true
    },
    holder: {
      type: Object,
      required: true
    },
    updateContainerBounds: {
      type: Function,
      required: false
    },
    holders: {
      type: Object,
      required: true
    }
  },
  mounted() {
    const {holder, updateContainerBounds} = this;
    this.holders[this.transform.id] = {
      updateContainerBounds,
      holder
    }
  },
  beforeDestroy() {
    delete this.holders[this.transform.id];
  }
}
</script>
